import './index.css';

import React, { useEffect, useState } from 'react';

import http from '../../../api/http';
import RecordSection from '../../view/RecordSection';

const RecordHealthSection = ({ section, id }) => {
  const [assessment, setAssessment] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let active = true;

    const loadHealth = async () => {
      setLoading(true);
      setError('');
      setAssessment(null);
      try {
        const { data } = await http.get(`/health/${encodeURIComponent(section)}/${encodeURIComponent(id)}`);
        if (!data || !data.health || !Array.isArray(data.health.signals)) {
          throw new Error('The health response did not contain an assessment.');
        }
        if (active) setAssessment(data);
      } catch (requestError) {
        if (active) setError(requestError?.response?.data?.message || requestError.message || 'Unable to load health assessment.');
      } finally {
        if (active) setLoading(false);
      }
    };

    if (section && id) loadHealth();
    return () => { active = false; };
  }, [section, id]);

  return (
    <RecordSection title="Evidence-based health" className="record-health">
      {loading ? <p>Assessing linked evidence...</p> : null}
      {error ? <p className="error-text">{error}</p> : null}
      {!loading && !error && assessment ? (
        <>
          <div className="record-health-summary">
            <span className={`record-health-badge record-health-${assessment.health.status}`}>
              {String(assessment.health.status).replace(/_/g, ' ')}
              {assessment.health.score === null ? '' : ` · ${assessment.health.score}/100`}
            </span>
            <span>
              Declared: <strong>{assessment.declaredStatus || 'Not set'}</strong>
            </span>
            {assessment.drift === true ? <strong className="record-health-drift">Declared status differs from evidence</strong> : null}
          </div>
          <p>{assessment.health.explanation}</p>
          {assessment.health.signals.length ? (
            <ul className="record-health-signals">
              {assessment.health.signals.map((signal) => (
                <li key={signal.key}>
                  <strong>{signal.label}</strong>
                  <span>{signal.summary}</span>
                  {Array.isArray(signal.evidence) && signal.evidence.length ? (
                    <ul>
                      {signal.evidence.slice(0, 5).map((item) => (
                        <li key={item.id}>{item.title || item.label || item.id}</li>
                      ))}
                    </ul>
                  ) : null}
                </li>
              ))}
            </ul>
          ) : null}
          {assessment.evidence.truncated ? <p className="muted-text">Some linked records were omitted by the traversal limit.</p> : null}
        </>
      ) : null}
    </RecordSection>
  );
};

export default RecordHealthSection;
